import referImg from "../../../../images/refer.png";

const ReferGroupsBanner = () => {
  return (
    <div className="refer-groups-banner">
      <div className="refer-group-head">
        <img
          src={referImg}
          alt=""
          className="refer-groups-icon refer-groups-icon-front"
        />
        <div className="refer-groups-text">
          <h3 className="refer-groups-title">Refer Groups</h3>
          <p className="refer-groups-subtitle">
            Help fuel our growth and expand the circle
          </p>
        </div>
      </div>
      {/* "Share Chant" button removed for now (had no onClick handler wired up).
          Re-add once the share flow is built. */}
    </div>
  );
};

export default ReferGroupsBanner;
